import { render } from "./app.vue.js?vue&type=template&id=09474756!=!../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./app.vue?vue&type=template&id=09474756"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__